import React from 'react'
import { Card, Col, Row, Table } from 'antd';
const { Column } = Table;
import {
    PhoneOutlined,
    MailOutlined,
    UsergroupAddOutlined,
    UserSwitchOutlined,
    UserOutlined,
    CheckCircleOutlined,
    HeartTwoTone
} from '@ant-design/icons'
import moment from 'moment'
import api_url from '../../../utils/requestApi'
import appConst from '../../../constents/app.const'

class Account extends React.Component{
    constructor(props){
        super(props)
    }
    state={}
    componentDidMount(){}
    render(){
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={9} xl={9}></Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} style={{background: 'white'}}>
                        <Card>
                            <div className="sidemenu" style={{textAlign: 'center'}}>
                                <div className="user-info">
                                    <div className="profile-lg-img-holder">
                                        <img src={appConst.apiUrl+api_url.profileImg+(this.props.userInfo?.image?this.props.userInfo.image:"pro.png")}/>
                                    </div>
                                </div>
                                    <div className="user-info-personal-info mt-5">
                                        <h3>Personal Information</h3>
                                        <span>
                                            <UserOutlined /> {this.props.userInfo?.name}
                                            <br/><UserOutlined /> {this.props.userInfo?.userId}
                                        </span>
                                    </div>
                                    <div  className="info-holder">
                                        <h4 className='mt-5'>Info</h4>
                                        <div style={{textAlign: 'left', float: 'left'}} className='p-10'>
                                            <span><PhoneOutlined /> {this.props.userInfo?this.props.userInfo.mobile:'01711223344'}</span>
                                            <br/>
                                            <span><MailOutlined /> {this.props.userInfo?this.props.userInfo.email:'test@gmail.com'}</span>
                                        </div>
                                        <div style={{textAlign: 'right'}} className='p-10'>
                                            <span><UsergroupAddOutlined /> {this.props.userInfo?.club}</span>
                                            <br/>
                                            <span><UserSwitchOutlined /> {this.props.userInfo?.sponsor}</span><br/>
                                            <span>PromoId: {this.props.userInfo?.promo}</span>
                                        </div>
                                    </div>
                                    <div  className="info-holder">
                                        <h4 className='mt-5'>Status</h4>
                                        <div className='p-10' style={{color: (this.props.userInfo.active == 1)?'green':'red'}}>
                                            <span><HeartTwoTone twoToneColor="green"/> {this.props.userInfo?.balance}</span>
                                            <br/>
                                            <span><CheckCircleOutlined/> {(this.props.userInfo.active == 1)?'Active':'Inactive'}</span>
                                            <br/>
                                            {this.props.userInfo?moment(this.props.userInfo.born).format('LLL'): 'Jan 01, 2023 00:00 AM'}
                                            <span style={{fontSize: '10px'}}>(join date)</span>
                                        </div>
                                    </div>
                                    <ul>
                                        <li className="logout-holder" 
                                            //onClick={props.logOut}
                                        >Log Out</li>
                                    </ul>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={9} xl={9}></Col>
                </Row>
            </div>
        )
    }
}

export default Account;